<template>
  <div class="wrapper pr">
    <serve-item @service-type-id="selServiceType">
    </serve-item>
    <div class="wrap-form">
      <serve-list
        :serviceTypeId="serviceTypeId"
        ref="table">
      </serve-list>
    </div>
  </div>
</template>

<script>
import ServeItem from './ServeItem.vue'
import ServeList from './ServeList.vue'

export default {
  name: 'ServeCentreManage',
  components: {
    'serve-item': ServeItem,
    'serve-list': ServeList
  },
  created () {
    this.callback = () => { this.updateServeList() }
    this.$bus.$on('updateServeList', this.callback)
  },
  destroyed () {
    this.$bus.$off('updateServeList', this.callback)
  },
  data () {
    return {
      serviceTypeId: ''
    }
  },
  methods: {
    selServiceType (val) {
      this.serviceTypeId = val
    },
    updateServeList () {
      this.$refs.table.getTableData()
    }
  }
}

</script>

<style lang="scss" scoped>

  .wrapper {
    display: flex;
    .wrap-form {
      flex-grow: 1;
      margin-left: 10px;
      box-sizing: border-box;
    }
  }

  .edit-page {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 2001;
    background-color: #eee;
  }
</style>
